import {ArianeStore} from "./ariane.store";
import {ArianeElement} from "./ariane.resources.provided";
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";

@Component({
    selector: 'ariane',
    templateUrl: './ariane.component.html'
})
export class ArianeComponent implements OnInit {

    elements: Array<ArianeElement>;
    domain: String;

    constructor(private router: Router, private arianeStore: ArianeStore) {
        let domain = location.hostname;
        this.domain = domain.split(".").splice(1).join(".");
    };

    ngOnInit() {
        this.arianeStore.onElementsUpdate().subscribe(elements => {
            this.elements = elements;
        })
    }

    goTo(route: string) {
        this.router.navigate([route]);
    }

    goToRouteIndex(index: number) {
        let route = "/cerba/";
        route += this.elements[index].route;
        this.goTo(route);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/ariane/ariane.component.ts